import { render } from "./PublicationAiOutline.vue?vue&type=template&id=4545bba2"
import script from "./PublicationAiOutline.vue?vue&type=script&lang=js"
export * from "./PublicationAiOutline.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__